import { mixedVolume } from "./audioSettings";

let previewContext: AudioContext | undefined;
let previewTimer = 0;

function context(): AudioContext | undefined {
  const AudioContextCtor =
    globalThis.AudioContext ??
    (globalThis as typeof globalThis & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AudioContextCtor) return undefined;
  previewContext ??= new AudioContextCtor();
  if (previewContext.state === "suspended") void previewContext.resume();
  return previewContext;
}

export function playSfxPreview(): void {
  const audio = context();
  if (!audio) return;
  const start = audio.currentTime + 0.005;
  const volume = mixedVolume("sfx", 0.055);
  if (volume <= 0) return;
  const oscillator = audio.createOscillator();
  const gain = audio.createGain();
  oscillator.type = "square";
  oscillator.frequency.setValueAtTime(220, start);
  oscillator.frequency.exponentialRampToValueAtTime(72, start + 0.07);
  gain.gain.setValueAtTime(volume, start);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.07);
  oscillator.connect(gain);
  gain.connect(audio.destination);
  oscillator.start(start);
  oscillator.stop(start + 0.08);
}

export function playVoicePreview(): void {
  const audio = context();
  if (!audio) return;
  const start = audio.currentTime + 0.005;
  const volume = mixedVolume("voice", 0.055);
  if (volume <= 0) return;
  const oscillator = audio.createOscillator();
  const gain = audio.createGain();
  oscillator.type = "sawtooth";
  oscillator.frequency.setValueAtTime(230, start);
  oscillator.frequency.exponentialRampToValueAtTime(160, start + 0.06);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(volume, start + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.06);
  oscillator.connect(gain);
  gain.connect(audio.destination);
  oscillator.start(start);
  oscillator.stop(start + 0.065);
}

export function scheduleBusPreview(bus: "sfx" | "voice"): void {
  if (previewTimer) window.clearTimeout(previewTimer);
  previewTimer = window.setTimeout(() => {
    if (bus === "sfx") playSfxPreview();
    else playVoicePreview();
  }, 140);
}
